const EXTERNAL_PROTOCOLS = ['http:', 'https:', 'mailto:', 'tel:'];

/**
 * Native app only: hands links that leave the app (chat links, patch notes,
 * `mailto:`, calendar links, `window.open`) to the system browser or mail
 * client. The WebView would otherwise navigate itself away from the app or
 * silently ignore a new window. Blob and data URLs are not external and keep
 * their default behavior.
 */
export function routeExternalLinksToSystem(): void {
  const open = (href: string): boolean => {
    const url = new URL(href, document.baseURI);
    if (!EXTERNAL_PROTOCOLS.includes(url.protocol) || url.origin === location.origin) return false;
    import('@tauri-apps/plugin-opener')
      .then(({ openUrl }) => openUrl(url.href))
      .catch((e) => console.error('failed to open external link', e));
    return true;
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    const anchor = (event.target as Element | null)?.closest('a[href]');
    if (anchor instanceof HTMLAnchorElement && open(anchor.href)) event.preventDefault();
  });

  window.open = (url?: string | URL) => {
    if (url) open(String(url));
    return null;
  };
}
